import { render } from "./AssignPeopleGroupForm.vue?vue&type=template&id=2b182e5f"
import script from "./AssignPeopleGroupForm.vue?vue&type=script&lang=js"
export * from "./AssignPeopleGroupForm.vue?vue&type=script&lang=js"

import "./AssignPeopleGroupForm.vue?vue&type=style&index=0&id=2b182e5f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__